import { Wand2 } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui';
import { Tabs, type TabItem } from '~/components/ui/Tabs';
import { CurrentProducts, PricingTab } from './sections';

export function MyProducts() {
  const { t } = useTranslation('my-product');
  const navigate = useNavigate();

  const tabs: TabItem[] = [
    {
      label: t('tabs.my_products'),
      link: 'current',
      component: <CurrentProducts />,
    },
    {
      label: t('tabs.pricing'),
      link: 'pricing',
      component: <PricingTab />,
    },
  ];

  const headerActions = (
    <Button
      variant="secondary"
      size="sm"
      width="auto"
      onClick={() => navigate('/my-products/import')}
    >
      <Wand2 size={16} />
      {t('header.smart_import')}
    </Button>
  );

  return (
    <Tabs
      title={t('header.title')}
      tabs={tabs}
      basePath="my-products"
      headerActions={headerActions}
    />
  );
}
